<nx-message *ngIf="visible" context="info" class="nx-margin-bottom-m" closable (close)="close()">
  <div>
    <b>{{ 'coverage-information.description' | translate }}</b>
  </div>
  <ul nxList>
    <li>{{ 'coverage-information.item1' | translate }}</li>
    <li>{{ 'coverage-information.item2' | translate }}</li>
    <li>{{ 'coverage-information.item3' | translate }}</li>
    <li>{{ 'coverage-information.item4' | translate }}</li>
  </ul>
</nx-message>
